<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <em-filter-tree class="col-lg-3 float-lg-left"
                            filterEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="emAdmFactoryModelEafmResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                          <em-button type="gotoChild"
                                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                                   custom-icon="fa fa-fw fa-lg fa-link"
                                                                   custom-label="工厂模型对计算属性"
                                                                   @click="popEmrec(row)">
                                          </em-button>
                                          <em-button type="gotoChild"
                                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                                   custom-icon="fa fa-fw fa-lg fa-crop"
                                                                   custom-label="工厂模型对设备"
                                                                   @click="popBarem(row)">
                                          </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
      <sub-entity-list ref="emrecEntityList" sub-entity="emSicEafmREocEmrec"
                       parent-field="emrecIdEafm"></sub-entity-list>
      <sub-entity-list ref="baremEntityList" sub-entity="emArchBdaREafmBarem"
                       parent-field="baremIdEafm"></sub-entity-list>
    </div>
</template>
<script>
    // Author yujiabei
    // Date 2021-07-14 17:07:59

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import subEntityList from "@/components/em/EmModal/SubEntityList";

    export default {
        name: "emAdmFactoryModelEafmLevelTreeListView",
        mixins: [emLevelTreeListMixin],
        components: {EmFilter, EmFilterTree,subEntityList},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
      methods:{
        popEmrec(row){
          this.$refs.emrecEntityList.showModal(row.id)
        },
        popBarem(row){
          this.$refs.baremEntityList.showModal(row.id)
        },
      }
    }
</script>